import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';
import React from 'react'
import * as XLSX from "xlsx";

type ExportModalProps = {
    rows: any,
    showDialog: boolean,
    setShowDialog: (showDialog: boolean) => void
}

export default function AddExportModalControl(props: ExportModalProps) {
    const { rows, showDialog, setShowDialog } = props;

    function downloadXLSX(rows: any) {

        console.log(rows);
        let r = [...rows].map(r => {
            // delete r['id'];
            r['truck'] = r['truck'].truck_number;
            return r;
        });
        // let s = [header, ...r];

        const ws = XLSX.utils.json_to_sheet(r);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Export');

        XLSX.writeFile(wb, "Manifest.xls"); // <-- just do it this way.
    }

    return (
        <>
            <Dialog
                open={showDialog}
                onClose={() => setShowDialog(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
                    Download Manifest Report
                </DialogTitle>
                <DialogContent style={{ width: '300px' }}>

                </DialogContent>
                <DialogActions>
                    <Button variant='contained' onClick={() => setShowDialog(false)} autoFocus fullWidth={true} >
                        <Typography variant="h6" component="h4" style={{ width: '100%', textAlign: 'center' }}>Close</Typography>
                    </Button>
                    <Button variant='contained' color='secondary' onClick={() => downloadXLSX(rows)} autoFocus fullWidth>
                        <Typography variant="h6" component="h4" style={{ width: '100%', textAlign: 'center' }}>Download</Typography>
                    </Button>

                </DialogActions>
            </Dialog>
        </>
    )
}
